import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { NotTranslated, T } from '../../../../Translations';
import StatusChip from '../../StatusChip';
import { ConnectionSummary, vendorName } from '../../Types';

interface Props {
  connection: ConnectionSummary;
}

const domainCount = (count: number): React.ReactElement => {
  switch (count) {
    case 0:
      return <T kind="No domains assigned" />;
    case 1:
      return <T kind="1 domain assigned" />;
    default:
      return (
        <>
          {count} <T kind="domains assigned" />
        </>
      );
  }
};

const ConnectionRow: React.FC<Props> = ({ connection }) => (
  <div className="flex items-start justify-between gap-4 border-b border-border py-4 last:border-b-0">
    <div className="min-w-0">
      <span className="block font-semibold text-foreground">
        <NotTranslated text={connection.displayName} />
      </span>
      <span className="block text-sm text-muted-foreground">
        <T kind={vendorName(connection.vendor)} /> &middot;{' '}
        <span className="font-mono text-xs">{connection.providerName}</span>
      </span>
      <span className="block text-sm text-muted-foreground">
        {domainCount(connection.assignedDomainCount)}
      </span>
    </div>
    <div className="flex shrink-0 flex-col items-end gap-2">
      <StatusChip status={connection.status} />
      <Link
        to={`/single_sign_on/connections/${connection.id}`}
        className="text-sm font-semibold text-primary hover:underline"
        data-intercom-target="sso-manage-connection-link"
      >
        {connection.status === 'awaiting_metadata' || connection.status === 'verifying' ? (
          <T kind="Continue setup" />
        ) : (
          <T kind="Manage" />
        )}
      </Link>
    </div>
  </div>
);

export default observer(ConnectionRow);
